import React from "react";
import Subscribe from "./Subscribe";
import PT from "prop-types";
import ActiveSubscription from "./ActiveSubscription";
import { useTranslation } from "react-i18next";
import { Wrap, WrapToCenter } from "./styled";
import { connect } from "react-redux";
import { Selectors } from "@/store/premium/selectors";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Effects } from "@/store/premium/effects";
import { Spin } from "_c/preloader";
import moment from "moment";

const Premium = (props) => {
  const { t, ready } = useTranslation(["premium", "errors"], {
    useSuspense: false,
  });
  if (!ready) return <Spin />;
  return (
    <WrapToCenter>
      <Wrap className={props.className}>
        {!props.hideActiveSubscription && (
          <ActiveSubscription
            t={t}
            isActive={props.isActive}
            isTrial={props.isTrial}
            expires={props.expires}
            cancel={props.cancel}
          />
        )}
        <Subscribe
          t={t}
          user={props.user}
          activateTrial={props.activateTrial}
          allowTrial={props.allowTrial}
          isActive={props.isActive}
          isTrial={props.isTrial}
          currency={props.currency}
          role={props.role}
          hideFeaturesList={props.hideFeaturesList}
        />
      </Wrap>
    </WrapToCenter>
  );
};
Premium.propTypes = {
  isGift: PT.bool,
  className: PT.string,
  allowTrial: PT.bool.isRequired,
  isTrial: PT.bool.isRequired,
  user: PT.string,
  expires: PT.string,
  currency: PT.string,
  role: PT.string,
  hideFeaturesList: PT.bool,
  hideActiveSubscription: PT.bool,

  activateTrial: PT.func,
  cancel: PT.func,
};
export default connect(
  (state, props) => {
    const userId = UserSelectors.getUserId(state);
    const isGift = props.user ? props.user !== userId : false;
    const expires = isGift ? props.expires : Selectors.getExpires(state);
    const isActive = expires ? moment(expires).isAfter(moment()) : false;
    return {
      isActive,
      isTrial: isGift ? false : Selectors.isTrial(state),
      allowTrial: isGift ? false : Selectors.getAllowTrial(state),
      expires,
      currency: UserSelectors.getCurrency(state),
    };
  },
  {
    activateTrial: Effects.activateTrial,
    cancel: Effects.cancel,
  },
)(Premium);
